<template lang="pug">
div.u-mt-md
  .grid.is-labs.is-ultrawide-9.is-widescreen-10.is-desktop-11.is-center
    .column

    Query(
      :query="require('~/graphql/Article.gql').Articles"
      :limit="6"
      :variables="({ first, after }) => ({ first, after, publishedIn: scope })"
      :initialValue="articles"
      v-slot="{ items }"
    )
      .grid.is-labs
        template(v-for="(article, idx) in items" )
          .column.is-12.u-mb-sm(v-if="idx == 0" :key="article.id")
            AppSection( :img="article.thumb" :img-alt="article.title" :url="`/articles/${article.slug}`" class=" is-reversed" ratio="5:3")
              h3.u-mb-0: AppLink(:to="`/articles/${article.slug}`") {{ article.title }}

          .column.is-desktop-4.is-tablet-6(v-else :key="article.id" )
            AppCard(:img="article.thumb" :title="article.title" :url="`/articles/${article.slug}`" ratio="5:3")

  .u-divider.u-mt-md(v-if="books && books.length || resources && resources.length")

  section.u-mt-md(v-if="books && books.length")
    .grid.is-labs
      .column.is-desktop-4.u-mb-sm
          h2 {{ $t('books') }}
          p.u-text-lg {{ $t(`${lab}.books.tagline`) }}
          .u-mt-xs
            AppLink(:to="`/books/${lab}`" class="button-link is-medium ") {{ $t('moreBooks') }}
      template(v-for="(book, idx) in books" )
        .column.is-desktop-4.is-tablet-6.u-mb-xs(v-if="idx == 0 || idx == 1" :key="book.id")
          AppCard(:img="book.thumb" :title="book.title" :url="`/books/${book.slug}`" ratio="4:5")
        .column.is-tablet-6.u-mb-xs(v-else :key="book.id")
          AppCard(:img="book.thumb" :title="book.title" :url="`/books/${book.slug}`" :boxed="book.backgroundColor")

  .u-divider.u-mt-md(v-if="resources && resources.length && books && books.length")

  section.u-mt-md(v-if="resources && resources.length")
    .u-flex-center.u-mb-sm
      h2.u-mb-0 {{ $t(`${lab}.resources.title`) }}
    .grid.is-labs.is-desktop-3.is-tablet-6.u-mb-sm
      .column(v-for="(resource, idx) in resources" :key="resource.id")
          AppCard(:img="resource.thumb" :title="resource.title" :url="lab === 'BIZ' ? '#soon' : resource.url" ratio="4:5" :soon="lab === 'BIZ'")
    AppLink(:to="`/${$t(`${lab}.resources.title`).split(' ').join('-').toLowerCase()}`" class="button-link is-medium") {{ $t('more') }} {{ $t(`${lab}.resources.title`) }}

  //- .u-divider.u-mt-md(v-if="tools && tools.length")

  //- .grid.is-labs.is-ultrawide-9.is-widescreen-10.is-desktop-11.is-center(v-if="tools && tools.length")
  //-   .column
  //-     section.u-mt-md
  //-       .u-flex-center.u-mb-sm
  //-         h2.u-mb-0 {{ $t('tools') }}
  //-       .grid.is-small.is-middle
  //-         template(v-for="(tool, idx) in tools" )
  //-           .column(:key="tool.id" :class="{'is-desktop-6' : idx == 0 , 'is-desktop-5': idx == 1}")
  //-             AppCard.is-large(:title="tool.title" :img="tool.thumb" :img-alt="tool.title" :url="tool.url" :excerpt="tool.description" :ratio="(idx == 0) ? '2-1' : '1-1'" )
  //-           .column.is-desktop-1(v-if="idx == 0")
  //-       .u-mt-sm
  //-         AppLink(to="/tools" class="button-link is-medium") {{ $t('moreTools') }}
  .u-mb-md
</template>

<script>
import { generateSeoMeta } from '~/utils/seo';
import LabContent from '~/graphql/Labs.gql';
import labsMap from '~/assets/data/labs.json';
import resourcesMap from '~/assets/data/resources.json';
import Query from '~/components/Query';
import AsymetricGrid from '~/components/PsudoRandomGrid';

export default {
  scrollToTop: true,
  components: {
    Query,
    AsymetricGrid
  },
  head() {
    const generator = generateSeoMeta(
      {
        title: `${this.lab}.title`,
        description: `${this.lab}.description`,
        image: `${this.lab}.shareImage`
      },
      { i18n: true }
    );

    return generator.call(this);
  },
  // here we load the data for the component
  async asyncData({ app, params }) {
    const { data } = await app.$api.query({
      query: LabContent,
      variables: {
        publishedIn: labsMap[params.lab],
        type: params.lab === 'technology' ? undefined : resourcesMap[params.lab]
      }
    });

    return {
      scope: labsMap[params.lab],
      lab: params.lab,
      articles: data.articles,
      books: data.books.edges.map(e => e.node),
      resources: data.resources.edges.map(e => e.node)
    };
  }
};
</script>

<i18n>
{
  "en": {
    "tools": "Tools",
    "articles": "Articles",
    "books": "Books",
    "more": "More",
    "moreArticles": "More Articles",
    "moreBooks": "More Books",
    "moreTools": "More Tools",
    "business": {
      "title": "Baianat Business Labs",
      "description": "Read all about business, marketing, social media and more. Find books, articles and resources in Baianat business labs.",
      "shareImage": "/share/labs/business.png",
      "resources": {
        "title": "Resources",
        "tagline": "Free downloadable templates t o help you plan out your next project."
      },
      "books": {
        "title": "Books",
        "tagline": "In depth materials to help businesses and individuals accelerate their processes.",
        "getBook": "Read Book"
      }
    },
    "design": {
      "title": "Baianat Design Labs",
      "description": "Discover more on branding, type design, animation, UX, product design, advertising through articles, books and tools.",
      "shareImage": "/share/labs/design.png",
      "resources": {
        "title": "Resources",
        "tagline": "Free downloadable illustrations and artwork for inspiration."
      },
      "books": {
        "title": "Books",
        "tagline": "Recharge your creative battery with the essential principles and theories of design.",
        "getBook": "Read Book"
      }
    },
    "technology": {
      "title": "Baianat Technology Labs",
      "description": "Explore technology lab and stay up to date with the latest technology trends and updates with articles and books.",
      "shareImage": "/share/labs/technology.png",
      "books": {
        "title": "Books",
        "tagline": "Feed the geek inside and build up your knowledge base in various technology branches.",
        "getBook": "Read Book"
      },
      "resources": {
        "title": "Resources",
        "tagline": "Our contributions to the open source community."
      }
    },
    "development": {
      "title": "Baianat development Labs",
      "description": "Learn more on mobile development, SaaS, and custom development through articles, books, open source projects and tools.",
      "shareImage": "/share/labs/code.png",
      "resources": {
        "title": "Open Source",
        "tagline": "Our contributions to the open source community."
      },
      "books": {
        "title": "Books",
        "tagline": "Read more on the latest hacks for both mobile and web development careers.",
        "getBook": "Read Book"
      }
    }
  },
  "ar": {
    "tools": "الأدوات",
    "articles": "مقالات",
    "books": "الكتب",
    "more": "المزيد",
    "moreArticles": "مقالات أكثر",
    "moreBooks": "المزيد من الكتب",
    "moreTools": "أدوات أكثر",
    "business": {
      "title": "مختبرات البيزنس",
      "description": "اقرأ كل شيء حول البيزنس ومجالاتها، وأعثر على الكتب والمقالات والموارد المفيدة لك عبر مختبرات البيزنس.",
      "shareImage": "/share/labs/business.png",
      "resources": {
        "title": "الموارد",
        "tagline": "Free downloadable templates t o help you plan out your next project."
      },
      "books": {
        "title": "الكتب",
        "tagline": "نساعد الأفراد والشركات على تحسين عملياتهم عبر مواد مكثفة.",
        "getBook": "اقرا الكتاب"
      }
    },
    "design": {
      "title": "مختبرات التصميم",
      "description": "استكشف المزيد حول العلامة التجارية  وتصميم الخطوط و الرسوم المتحركة و تجربة المستخدم من خلال المقالات والكتب والأدوات.",
      "shareImage": "/share/labs/design.png",
      "resources": {
        "title": "Resources",
        "tagline": "Free downloadable illustrations and artwork for inspiration."
      },
      "books": {
        "title": "الكتب",
        "tagline": "أعد شحن بطاريتك الإبداعية من خلال المبادئ الأساسية ونظريات التصميم.",
        "getBook": "اقرا الكتاب"
      }
    },
    "technology": {
      "title": "مختبرات التكنولوجيا",
      "description": "اكتشف مختبر التكنولوجيا وابق على اطلاع على أحدث اتجاهات التقنية والتحديثات، واقرأ المقالات والكتب المفيدة التي تثري عقلك",
      "shareImage": "/share/labs/technology.png",
      "resources": {
        "title": "المصادر المفتوحة",
        "tagline": "اسهاماتنا في البرمجيات مفتوحة المصدر."
      },
      "books": {
        "title": "الكتب",
        "tagline": "Feed the geek inside and build up your knowledge base in various technology branches.",
        "getBook": "اقرا الكتاب"
      }
    },
    "development": {
      "title": "مختبرات البرمجة",
      "description": "اعرف المزيد حول برمجة التطبيقات والمواقع والبرمجة الخاصة عبر المزيد من الكتب والمقالات والأدوات والمشاريع مفتوحة المصدر",
      "shareImage": "/share/labs/code.png",
      "resources": {
        "title": "المصادر المفتوحة",
        "tagline": "اسهاماتنا في البرمجيات مفتوحة المصدر."
      },
      "books": {
        "title": "الكتب",
        "tagline": "اقرأ المزيد عن أحدث النصائح حول  تطوير الموقع الإلكتروني وتطبيقات الجوال.",
        "getBook": "اقرا الكتاب"
      }
    }
  }
}
</i18n>
